import { render, staticRenderFns } from "./TaxDocuments.vue?vue&type=template&id=e968c93c"
import script from "./TaxDocuments.vue?vue&type=script&lang=js"
export * from "./TaxDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports